import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  constructor() {}

 }




// WEBPACK FOOTER //
// C:/Users/m.altmann/Documents/Projekte/telegärtner/tg-pwa/src/app/app.component.ts